import request from "root/js/request";
import { getPreviousFullMonthDates, getServerDate } from "root/utils/date";

export const getWBDynamicKeywordsStatByIDMonthlyDynamic = async ({
  keyword_id,
  date_from,
  date_to,
  predict_trend,
  predict_trand = predict_trend,
  period,
  ...rest
}) => {
  // Эта логика важна при получении предсказаний по месяцам. Если не ограничить даты на предыдущий месяц
  // то прогноз построится с учётом дней текущего, тк keywords_stat хранит данные по дням, а monthly_dynamic
  // просто группирует их по месяцам
  const correctEndDate =
    predict_trand && !date_to ? getServerDate((getPreviousFullMonthDates() || [])[1]) : date_to;
  //
  const response = await request({
    url: `/wb_dynamic/keywords_stat/${keyword_id}/monthly_dynamic/`,
    method: "get",
    params: {
      date_from,
      //
      date_to: correctEndDate,
      //
      predict_trand,
      period,
      ...rest,
    },
  });
  return response.data;
};
